export default __webpack_public_path__ + "static/customer2-1e486a1973461f62fc25686f62c8fe96.jpg";